import { Typography, useTheme } from "@mui/material";
import React, {
	FC,
	FunctionComponent,
	MouseEventHandler,
	SVGProps,
} from "react";
import COMMON_FIELDS from "../../../../../../../general/constants/commonFields";
import * as ST from "./styled";
import BreakPoints from "src/general/constants/breakPoints";

type ItemNavMenuModuleProps = {
	[COMMON_FIELDS.LINK]: string;
	[COMMON_FIELDS.IS_ACTIVE]: boolean;
	[COMMON_FIELDS.LABEL]: string;
	[COMMON_FIELDS.ICON]: FunctionComponent<SVGProps<SVGSVGElement>>;
	[COMMON_FIELDS.ON_CLICK]?: MouseEventHandler<any>;
};

const ItemNavMenuModule: FC<ItemNavMenuModuleProps> = ({
	[COMMON_FIELDS.LINK]: link,
	[COMMON_FIELDS.IS_ACTIVE]: isActive,
	[COMMON_FIELDS.LABEL]: label,
	[COMMON_FIELDS.ICON]: Icon,
	[COMMON_FIELDS.ON_CLICK]: onClick,
}) => {
	const theme = useTheme();
	const isMediaQuery = window.matchMedia(
		`(min-width: ${BreakPoints.TABLET_1023}px) and (max-width: ${BreakPoints.LARGE_1439}px)`
	).matches;

	return (
		<ST.StyledLink
			theme={theme}
			to={link}
			onClick={onClick}
			isActive={isActive}
		>
			<Icon
				style={{
					color: isMediaQuery
						? isActive
							? theme.palette.common.white
							: theme.palette.text.secondary
						: isActive
						? theme.palette.primary.main
						: theme.palette.text.primary,
				}}
			/>
			;
			<ST.StyledTypography
				theme={theme}
				isActive={isActive}
			>
				{label}
			</ST.StyledTypography>
		</ST.StyledLink>
	);
};

export default React.memo(
	ItemNavMenuModule,
	(prevProps: ItemNavMenuModuleProps, nextProps: ItemNavMenuModuleProps) =>
		prevProps[COMMON_FIELDS.LINK] === nextProps[COMMON_FIELDS.LINK] &&
		prevProps[COMMON_FIELDS.IS_ACTIVE] === nextProps[COMMON_FIELDS.IS_ACTIVE] &&
		prevProps[COMMON_FIELDS.LABEL] === nextProps[COMMON_FIELDS.LABEL]
);
